import React, { useState } from "react";

function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = e => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold mb-6 text-green-800">Contact Us</h1>
      <div className="mb-8 flex flex-col items-center">
        <img src={require('../assets/uploads/2018/10/logo-design-new-300x39.png')} alt="DivineWellness Logo" className="h-12 mb-4" />
        <div className="mb-2 font-semibold">Address:</div>
        <div>Divine Wellness, behind Satkar Hall, Subhas Chowki, Mahoba, Uttar Pradesh, 210427</div>
        <div className="mb-2 font-semibold mt-4">Phone:</div>
        <div><a href="tel:+911234567890" className="text-green-700">+91 8360068653</a></div>
        <div className="mb-2 font-semibold mt-4">Email:</div>
        <div><a href="mailto:info@divinewellness.com" className="text-green-700">info@divinewellness.com</a></div>
        <div className="mt-4">
          <a href="https://wa.me/911234567890" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">
            WhatsApp Us
          </a>
        </div>
      </div>
      <iframe
        title="Google Map"
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4075.1990544817945!2d79.8690413118741!3d25.2920141543511!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3982ccde7155fe9f%3A0x4e5d290f0247e37b!2z4KSv4KWL4KSXIOCkj-CkteCkgiDgpKrgpY3gpLDgpL7gpJXgpYPgpKTgpL_gpJUg4KSa4KS_4KSV4KS_4KSk4KWN4KS44KS-IOCkleClh-CkguCkpuCljeCksA!5e0!3m2!1sen!2sus!4v1750489569168!5m2!1sen!2sus"
        width="100%"
        height="220"
        style={{ border: 0 }}
        className="rounded mb-8 border"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
      <form onSubmit={handleSubmit} className="bg-white shadow rounded p-6 flex flex-col gap-4">
        <input name="name" value={form.name} onChange={handleChange} required placeholder="Your Name" className="border rounded px-3 py-2" />
        <input name="email" type="email" value={form.email} onChange={handleChange} required placeholder="Your Email" className="border rounded px-3 py-2" />
        <textarea name="message" value={form.message} onChange={handleChange} required placeholder="Your Message" className="border rounded px-3 py-2" rows={4} />
        <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">Send Message</button>
        {submitted && <div className="text-green-700 mt-2">Thank you! We'll get back to you soon.</div>}
      </form>
    </div>
  );
}

export default Contact;
